module.exports = __webpack_public_path__ + "img/sobhy-kaber.fcfe3aed.jpg";